module.exports = __webpack_public_path__ + "img/r-163.23e983c0.jpg";